import createFetchActionCreators from './create-fetch-action-creators.js';
import fetch from './isomorphic-fetch-wrapper.js';
export const FETCH = 'fetch';
export const createActionCreators = (action) => {
    const { loadActionCreator, loadActionTypeOrCreator, failureActionCreator, failureActionTypeOrCreator, successActionCreator, successActionTypeOrCreator, } = action;
    const fetchActionCreators = createFetchActionCreators(Object.assign(Object.assign(Object.assign({}, (loadActionTypeOrCreator &&
        typeof loadActionTypeOrCreator !== 'function' && {
        loadActionType: loadActionTypeOrCreator,
    })), (failureActionTypeOrCreator &&
        typeof failureActionTypeOrCreator !== 'function' && {
        failureActionType: failureActionTypeOrCreator,
    })), (successActionTypeOrCreator &&
        typeof successActionTypeOrCreator !== 'function' && {
        successActionType: successActionTypeOrCreator,
    })));
    return {
        loadActionCreator: fetchActionCreators.loadActionCreator || loadActionTypeOrCreator || loadActionCreator,
        failureActionCreator: fetchActionCreators.failureActionCreator || failureActionTypeOrCreator || failureActionCreator,
        successActionCreator: fetchActionCreators.successActionCreator || successActionTypeOrCreator || successActionCreator,
    };
};
export default (store) => (next) => (action = {}) => {
    if (action.type !== FETCH) {
        return next(action);
    }
    const { payload, requestParams } = action;
    const actionCreators = createActionCreators(action);
    if (actionCreators.loadActionCreator) {
        store.dispatch(actionCreators.loadActionCreator(payload));
    }
    return fetch(requestParams)
        .then((data) => {
        var _a;
        const isGraphql = !!((_a = requestParams === null || requestParams === void 0 ? void 0 : requestParams.body) === null || _a === void 0 ? void 0 : _a.query);
        if (isGraphql) {
            if (data.data && actionCreators.successActionCreator) {
                store.dispatch(actionCreators.successActionCreator(data.data, payload));
            }
            if (data.errors)
                return Promise.reject({ data });
        }
        else if (actionCreators.successActionCreator) {
            store.dispatch(actionCreators.successActionCreator(data, payload));
        }
        return data;
    })
        .catch(({ body, status, data = {} }) => {
        var _a;
        const errors = data.errors || ((_a = body === null || body === void 0 ? void 0 : body.errors) !== null && _a !== void 0 ? _a : []);
        const error = {
            errors,
            status,
        };
        if (actionCreators.failureActionCreator) {
            store.dispatch(actionCreators.failureActionCreator(error, payload));
        }
        return Promise.reject(Object.assign(Object.assign({}, error), data));
    });
};
//# sourceMappingURL=fetch-middleware.js.map